import React from 'react'
import { useGoogleLogin } from '@react-oauth/google'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { Button } from 'components/ui/Button'

import { authApi, profileApi, callApi } from 'api'

import { setIsPro, logIn } from '../../store/actions'

const ProLogin = (props) => {
  const history = useHistory()

  const responseGoogle = async (res) => {
    await authApi
      .googleLogInPro({ access_token: res?.access_token })
      .then(async (res) => {
        if (res?.result?.access_token) {
          props.setIsPro(true)
          localStorage.setItem('token', res?.result.access_token)
          localStorage.setItem('refreshToken', res?.result.refresh_token)
          localStorage.setItem('isPro', true)
          profileApi.setProInfo({
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          })
          await profileApi.getProfileInfo().then((res) => {
            const pendingCancelCall = sessionStorage.getItem('pendingCancelCall')
            if (pendingCancelCall) {
              history.push(`/${res?.result?.profile?.channel_name}`)
            } else {
              history.push('/dashboard/pro')
            }
            props.logIn(res?.result?.profile)
          })
        }
      })

    if (res?.access_token) {
      authApi.getGoogleContacts(res.access_token).then((res) => {
        let contacts = res?.data?.connections?.filter((e) => e.emailAddresses)
        let emails = contacts?.map((e) => {
          return { email: e.emailAddresses[0].value, displayName: e.names[0].displayName }
        })
        callApi.saveContacts(JSON.stringify(emails))
      })
    }
  }

  const login = useGoogleLogin({
    onSuccess: responseGoogle,
    scope:
      'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid https://www.googleapis.com/auth/contacts.readonly',
    onError: (error) => console.error('Login Failed:', error),
  })

  return (
    <Button
      variant="tertiary"
      size="lg"
      iconName="google_white"
      fullWidth
      iconTextCenter
      onClick={() => login()}
    >
      Login with Google
    </Button>
  )
}

const mapStateToProps = ({ auth: { error } }) => ({
  authError: error,
})

const willMapDispatchToProps = {
  setIsPro,
  logIn,
}

export default connect(mapStateToProps, willMapDispatchToProps)(ProLogin)
